/*============================================================================
  Gift Wrap Functionality
==============================================================================*/
(function() {
  'use strict';

  var theme = window.theme || {};

  theme.GiftWrap = (function() {
    var selectors = {
      addButton: '.js-gift-wrap-add',
      closeButton: '.js-gift-wrap-close',
      confirmButton: '.js-gift-wrap-confirm',
      giftWrapDrawer: '[data-gift-wrap-drawer]',
      giftWrapUpsell: '[data-gift-wrap-upsell]',
      giftWrapConfig: '[data-gift-wrap-config]',
      giftMessageInput: '[data-gift-message-input]',
      charCount: '[data-char-count]'
    };

    function GiftWrap() {
      this.drawer = document.querySelector(selectors.giftWrapDrawer);
      
      if (!this.drawer) {
        console.warn('Gift wrap drawer not found');
        return;
      }

      this.closeButton = document.querySelector(selectors.closeButton);
      this.confirmButton = document.querySelector(selectors.confirmButton);
      this.messageInput = document.querySelector(selectors.giftMessageInput);
      this.charCountEl = document.querySelector(selectors.charCount);
      this.isOpen = false;
      this.currentVariantSize = null; // Track current gift wrap size
      this.isAdjusting = false; // Prevent recursive adjustments
      this.isRemoving = false; // Prevent adjustments during removal
      this.hasEligibleItems = true; // Track if cart has eligible items

      // Upsell, config and button will be found dynamically as they're loaded via AJAX
      this.upsell = null;
      this.addButton = null;
      this.configEl = null;
      
      console.log('GiftWrap initialized');

      this.init();
    }

    GiftWrap.prototype = Object.assign({}, GiftWrap.prototype, {
      init: function() {
        // Try to bind button initially (may not exist yet)
        this.bindAddButton();

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.close.bind(this));
        }

        if (this.confirmButton) {
          this.confirmButton.addEventListener('click', this.handleConfirm.bind(this));
        }

        if (this.messageInput) {
          this.messageInput.addEventListener('input', this.updateCharCount.bind(this));
        }

        // Listen for edit gift message clicks
        document.addEventListener('click', function(e) {
          if (e.target.classList.contains('js-edit-gift-message')) {
            e.preventDefault();
            this.handleEditMessage(e.target);
          }
          
          // Listen for gift wrap remove button clicks
          if (e.target.classList.contains('js-gift-wrap-remove') || e.target.closest('.js-gift-wrap-remove')) {
            e.preventDefault();
            var button = e.target.classList.contains('js-gift-wrap-remove') ? e.target : e.target.closest('.js-gift-wrap-remove');
            this.handleRemoveGiftWrap(button);
          }
        }.bind(this));

        // Listen for cart updates to show/hide upsell and check for auto-adjustment
        document.addEventListener('cart:updated', this.checkGiftWrapInCart.bind(this));
        
        // Also listen for cart build to rebind button when cart loads initially
        document.addEventListener('cart:build', function() {
          setTimeout(this.bindAddButton.bind(this), 100);
        }.bind(this));
        
        // Listen for new products being added - check adjustment after DOM updates
        document.addEventListener('ajaxProduct:added', function() {
          // Wait for cart to rebuild with new data, then check adjustment
          setTimeout(function() {
            this.checkGiftWrapAfterProductAdded();
          }.bind(this), 500);
        }.bind(this));
        
        // Hide notification when cart drawer closes
        document.addEventListener('cart:close', this.hideNotification.bind(this));
        
        // Also listen for drawer close button clicks
        document.addEventListener('click', function(e) {
          if (e.target.closest('.js-drawer-close') && e.target.closest('#CartDrawer')) {
            this.hideNotification();
          }
        }.bind(this));
      },
      
      bindAddButton: function() {
        // Remove old listener if exists
        if (this.addButton && this.boundHandleAdd) {
          this.addButton.removeEventListener('click', this.boundHandleAdd);
        }
        
        // Find upsell, config container and button
        this.upsell = document.querySelector(selectors.giftWrapUpsell);
        this.addButton = document.querySelector(selectors.addButton);
        this.configEl = document.querySelector(selectors.giftWrapConfig);
        
        // Load settings from persistent config element (always present)
        if (this.configEl) {
          this.usePoints = this.configEl.getAttribute('data-use-points') === 'true';
          this.smallCap = parseInt(this.configEl.getAttribute('data-small-cap')) || 5;
          this.largeCap = parseInt(this.configEl.getAttribute('data-large-cap')) || 15;
          this.smallVariantName = this.configEl.getAttribute('data-small-variant') || 'Small';
          this.largeVariantName = this.configEl.getAttribute('data-large-variant') || 'Large';
          this.giftWrapProductId = this.configEl.getAttribute('data-product-id');
          this.smallVariantId = this.configEl.getAttribute('data-small-variant-id');
          this.largeVariantId = this.configEl.getAttribute('data-large-variant-id');
          this.allowMultiple = this.configEl.getAttribute('data-allow-multiple') === 'true';
          this.upgradedText = this.configEl.getAttribute('data-upgraded-text') || 'Gift wrap upgraded to Large based on cart contents';
          this.downgradedText = this.configEl.getAttribute('data-downgraded-text') || 'Gift wrap changed to Small based on cart contents';
          this.adjustedText = this.configEl.getAttribute('data-adjusted-text') || 'Gift wrap adjusted to match your cart';
          this.hasEligibleItems = this.configEl.getAttribute('data-has-eligible-items') === 'true';
          
          // Load cart items points data (only eligible items are included from Liquid)
          try {
            var cartItemsData = this.configEl.getAttribute('data-cart-items');
            this.cartItemsPoints = cartItemsData ? JSON.parse(cartItemsData) : [];
            console.log('Loaded cart items points from config:', this.cartItemsPoints);
          } catch (e) {
            console.error('Error parsing cart items data from config:', e);
            this.cartItemsPoints = [];
          }
          
          this.smallOnlyPoints = parseInt(this.configEl.getAttribute('data-small-only-points')) || 0;
          
          console.log('Gift wrap config loaded:', {
            usePoints: this.usePoints,
            smallCap: this.smallCap,
            largeCap: this.largeCap,
            productId: this.giftWrapProductId,
            allowMultiple: this.allowMultiple,
            hasEligibleItems: this.hasEligibleItems
          });
        }
        
        if (this.addButton) {
          // Bind click handler
          this.boundHandleAdd = this.handleAdd.bind(this);
          this.addButton.addEventListener('click', this.boundHandleAdd);
          console.log('Gift wrap add button bound successfully');
        }
      },

      handleEditMessage: function(link) {
        var cartKey = link.getAttribute('data-cart-key');
        var giftMessage = link.getAttribute('data-gift-message');
        
        this.giftWrapKey = cartKey;
        
        // Pre-fill the message
        if (this.messageInput && giftMessage) {
          this.messageInput.value = giftMessage;
          this.updateCharCount();
        }
        
        this.open();
      },
      
      handleRemoveGiftWrap: function(button) {
        var key = button.getAttribute('data-key');
        if (!key) return;
        
        // Set flag to prevent auto-adjustment during removal
        this.isRemoving = true;
        
        // Disable button while processing
        button.disabled = true;
        button.textContent = '...';
        
        var self = this;
        
        // Remove all gift wrap items from cart
        fetch('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            // Find all gift wrap items
            var removePromises = [];
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].product_id == self.giftWrapProductId) {
                removePromises.push(
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: cart.items[i].key,
                      quantity: 0
                    })
                  })
                );
              }
            }
            return Promise.all(removePromises);
          })
          .then(function() {
            // Hide notification
            self.hideNotification();
            
            // Rebuild cart
            document.dispatchEvent(new CustomEvent('cart:build'));
            
            // Fetch updated cart
            return fetch('/cart.js');
          })
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            // Clear removal flag before dispatching event
            self.isRemoving = false;
            
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
          })
          .catch(function(error) {
            console.error('Error removing gift wrap:', error);
            self.isRemoving = false;
            button.disabled = false;
            button.textContent = 'Remove';
          });
      },

      calculateCartPoints: function(cart, excludeGiftWrap) {
        if (!cart || !cart.items) {
          return 0;
        }

        var totalPoints = 0;
        var giftWrapProductId = this.giftWrapProductId;

        // Create a lookup map from the stored cart items points data
        var pointsLookup = {};
        if (this.cartItemsPoints && this.cartItemsPoints.length > 0) {
          for (var j = 0; j < this.cartItemsPoints.length; j++) {
            var itemData = this.cartItemsPoints[j];
            pointsLookup[itemData.id] = itemData.pts;
          }
        }

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          
          // Skip gift wrap product if requested
          if (excludeGiftWrap && item.product_id == giftWrapProductId) {
            continue;
          }

          // Get points from our lookup map (populated from Liquid with metafield data)
          var itemPoints = 1; // Default to 1 point
          
          if (pointsLookup[item.variant_id]) {
            itemPoints = pointsLookup[item.variant_id];
          }

          totalPoints += itemPoints * item.quantity;
        }

        console.log('Calculated cart points:', totalPoints, 'from', cart.items.length, 'items');
        return totalPoints;
      },
      
      calculateSmallOnlyPoints: function(cart) {
        if (!cart || !cart.items) {
          return 0;
        }
        
        var smallOnlyTotal = 0;
        var giftWrapProductId = this.giftWrapProductId;
        
        // Build lookup for small-only flag from cartItemsPoints data
        var smallOnlyLookup = {};
        var pointsLookup = {};
        if (this.cartItemsPoints && this.cartItemsPoints.length > 0) {
          for (var j = 0; j < this.cartItemsPoints.length; j++) {
            var itemData = this.cartItemsPoints[j];
            pointsLookup[itemData.id] = itemData.pts;
            smallOnlyLookup[itemData.id] = itemData.small === 1;
          }
        }
        
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          
          if (item.product_id == giftWrapProductId) {
            continue;
          }
          
          if (smallOnlyLookup[item.variant_id]) {
            var itemPoints = pointsLookup[item.variant_id] || 1;
            smallOnlyTotal += itemPoints * item.quantity;
          }
        }
        
        return smallOnlyTotal;
      },

      getRequiredVariantSize: function(points) {
        if (!this.usePoints) {
          return null;
        }

        if (points <= this.smallCap) {
          return 'small';
        } else if (points <= this.largeCap) {
          return 'large';
        } else {
          return 'large'; // Default to large if over cap
        }
      },

      getVariantIdBySize: function(size) {
        // This will be called after fetching product data
        return new Promise(function(resolve, reject) {
          var productId = this.giftWrapProductId;
          if (!productId) {
            reject('No product ID');
            return;
          }

          fetch('/products/' + productId + '.js')
            .then(function(response) { return response.json(); })
            .then(function(product) {
              var variantName = size === 'small' ? this.smallVariantName : this.largeVariantName;
              
              for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                if (variant.title.indexOf(variantName) !== -1 || 
                    variant.option1 === variantName || 
                    variant.option2 === variantName || 
                    variant.option3 === variantName) {
                  resolve(variant.id);
                  return;
                }
              }
              
              // Fallback to first variant
              resolve(product.variants[0].id);
            }.bind(this))
            .catch(reject);
        }.bind(this));
      },

      checkGiftWrapInCart: function(e) {
        if (!e.detail || !e.detail.cart) {
          return;
        }

        var cart = e.detail.cart;
        var giftWrapInCart = false;

        // Skip if we're currently adjusting or removing to prevent recursive updates
        if (this.isAdjusting || this.isRemoving) {
          console.log('Skipping checkGiftWrapInCart - adjustment/removal in progress');
          return;
        }

        // Rebind and reload config after cart rebuild (DOM gets replaced)
        this.bindAddButton();

        // Check if gift wrap is in cart (collect all gift wrap items)
        var giftWrapItems = [];
        if (cart.items && this.giftWrapProductId) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].product_id == this.giftWrapProductId) {
              giftWrapInCart = true;
              giftWrapItems.push(cart.items[i]);
            }
          }
        }

        console.log('checkGiftWrapInCart:', {
          giftWrapInCart: giftWrapInCart,
          giftWrapItemCount: giftWrapItems.length,
          usePoints: this.usePoints,
          cartItemCount: cart.items ? cart.items.length : 0,
          hasEligibleItems: this.hasEligibleItems
        });

        // Show/hide upsell based on cart contents and eligible items
        if (this.upsell) {
          if (giftWrapInCart || !this.hasEligibleItems) {
            // Hide if gift wrap already in cart OR no eligible items
            this.upsell.style.display = 'none';
          } else {
            this.upsell.style.display = '';
            // Reset button state when upsell reappears
            this.resetAddButton();
          }
        }

        // Check if we need to auto-adjust gift wrap variants
        if (this.usePoints && giftWrapInCart && giftWrapItems.length > 0) {
          this.checkAndAdjustGiftWrapVariants(cart, giftWrapItems);
        }
      },

      checkAndAdjustGiftWrapVariants: function(cart, giftWrapItems) {
        var cartPoints = this.calculateCartPoints(cart, true);
        
        console.log('Checking gift wrap adjustment:', {
          cartPoints: cartPoints,
          smallCap: this.smallCap,
          largeCap: this.largeCap,
          currentItems: giftWrapItems.length,
          allowMultiple: this.allowMultiple,
          hasEligibleItems: this.hasEligibleItems
        });
        
        // If no eligible items in cart, remove all gift wrap
        if (!this.hasEligibleItems || cartPoints === 0) {
          console.log('No eligible items in cart, removing gift wrap');
          this.removeAllGiftWrap(giftWrapItems);
          return;
        }
        
        // Calculate what we should have
        var cartSmallOnlyPoints = this.calculateSmallOnlyPoints(cart);
        var shouldHave = this.calculateOptimalGiftWraps(cartPoints, cartSmallOnlyPoints);
        
        // Calculate what we currently have
        var currentLarge = 0;
        var currentSmall = 0;
        
        // Also collect current gift messages to preserve them
        var giftMessages = [];
        
        for (var i = 0; i < giftWrapItems.length; i++) {
          var item = giftWrapItems[i];
          if (item.variant_title && item.variant_title.indexOf(this.largeVariantName) !== -1) {
            currentLarge += item.quantity;
          } else if (item.variant_title && item.variant_title.indexOf(this.smallVariantName) !== -1) {
            currentSmall += item.quantity;
          }
          
          // Collect gift message if exists
          if (item.properties && item.properties['Gift Message']) {
            giftMessages.push(item.properties['Gift Message']);
          }
        }
        
        console.log('Current:', currentLarge, 'Large,', currentSmall, 'Small');
        console.log('Should have:', shouldHave.numLarge, 'Large,', shouldHave.numSmall, 'Small');
        
        // Check if adjustment is needed
        if (currentLarge !== shouldHave.numLarge || currentSmall !== shouldHave.numSmall) {
          console.log('Adjusting gift wraps to match optimal combination');
          
          // Determine notification type
          var notificationType = this.getNotificationType(currentLarge, currentSmall, shouldHave.numLarge, shouldHave.numSmall);
          
          this.adjustGiftWrapCombination(giftWrapItems, shouldHave, giftMessages, notificationType);
        }
      },
      
      getNotificationType: function(currentLarge, currentSmall, newLarge, newSmall) {
        var currentTotal = currentLarge + currentSmall;
        var newTotal = newLarge + newSmall;
        
        // Upgrading: going from small to large, or adding more wraps
        if (newLarge > currentLarge && newSmall <= currentSmall) {
          return 'upgraded';
        }
        // Downgrading: going from large to small, or removing wraps
        if (newSmall > currentSmall && newLarge < currentLarge) {
          return 'downgraded';
        }
        // Otherwise it's a general adjustment
        return 'adjusted';
      },
      
      removeAllGiftWrap: function(giftWrapItems) {
        // Set flag to prevent recursive updates
        this.isRemoving = true;
        
        var self = this;
        
        // Remove all gift wrap items
        var removePromises = giftWrapItems.map(function(item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        });
        
        Promise.all(removePromises)
          .then(function() {
            // Rebuild cart
            document.dispatchEvent(new CustomEvent('cart:build'));
            
            // Fetch updated cart
            return fetch('/cart.js');
          })
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            // Clear removal flag before dispatching event
            self.isRemoving = false;
            
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
          })
          .catch(function(error) {
            console.error('Error removing gift wrap:', error);
            self.isRemoving = false;
          });
      },
      
      calculateOptimalGiftWraps: function(points, smallOnlyPoints) {
        var smallOnly = smallOnlyPoints || 0;
        
        if (points <= this.smallCap) {
          return { numLarge: 0, numSmall: 1 };
        } else if (points <= this.largeCap) {
          return { numLarge: 1, numSmall: 0 };
        } else {
          // Multiple needed
          var numLarge = Math.floor(points / this.largeCap);
          var remaining = points % this.largeCap;
          var numSmall = 0;
          
          if (remaining > 0) {
            // Only assign a small for the remainder if there are explicitly
            // small-only products in the cart. Without them, always bump up
            // to another large to avoid incorrectly packaging regular items
            // in a small gift wrap.
            if (remaining <= this.smallCap && smallOnly > 0) {
              numSmall = 1;
            } else {
              numLarge += 1;
            }
          }
          
          return { numLarge: numLarge, numSmall: numSmall };
        }
      },
      
      checkAndAdjustGiftWrapVariant: function(cart, giftWrapItem) {
        // Legacy method - kept for compatibility
        var cartPoints = this.calculateCartPoints(cart, true);
        var requiredSize = this.getRequiredVariantSize(cartPoints);
        
        console.log('Checking gift wrap adjustment:', {
          cartPoints: cartPoints,
          requiredSize: requiredSize,
          smallCap: this.smallCap,
          largeCap: this.largeCap,
          currentVariant: giftWrapItem.variant_title
        });
        
        if (!requiredSize) {
          return;
        }

        // Determine current size from variant title
        var currentSize = null;
        if (giftWrapItem.variant_title.indexOf(this.smallVariantName) !== -1) {
          currentSize = 'small';
        } else if (giftWrapItem.variant_title.indexOf(this.largeVariantName) !== -1) {
          currentSize = 'large';
        }

        console.log('Current size:', currentSize, 'Required size:', requiredSize);

        // If size needs to change, update it
        if (currentSize && currentSize !== requiredSize) {
          console.log('Adjusting gift wrap from', currentSize, 'to', requiredSize);
          this.adjustGiftWrapVariant(giftWrapItem, requiredSize, currentSize);
        }
      },

      adjustGiftWrapCombination: function(currentItems, shouldHave, giftMessages, notificationType) {
        console.log('Adjusting gift wrap combination');
        
        // Set flag to prevent recursive updates
        this.isAdjusting = true;
        
        var self = this;
        var largeVariantId = this.largeVariantId;
        var smallVariantId = this.smallVariantId;
        
        // Remove all current gift wrap items
        var removePromises = currentItems.map(function(item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        });
        
        Promise.all(removePromises)
          .then(function() {
            // Add new combination
            var items = [];
            
            // Get the gift message to apply (use first one if multiple existed)
            var giftMessage = giftMessages && giftMessages.length > 0 ? giftMessages[0] : null;
            
            if (shouldHave.numLarge > 0 && largeVariantId) {
              var largeItem = {
                id: parseInt(largeVariantId),
                quantity: shouldHave.numLarge
              };
              // Apply gift message to first item
              if (giftMessage) {
                largeItem.properties = { 'Gift Message': giftMessage };
              }
              items.push(largeItem);
            }
            
            if (shouldHave.numSmall > 0 && smallVariantId) {
              var smallItem = {
                id: parseInt(smallVariantId),
                quantity: shouldHave.numSmall
              };
              // Apply gift message if we don't have large items
              if (giftMessage && shouldHave.numLarge === 0) {
                smallItem.properties = { 'Gift Message': giftMessage };
              }
              items.push(smallItem);
            }
            
            if (items.length === 0) {
              return Promise.resolve();
            }
            
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function(response) {
            if (response) {
              return response.json();
            }
          })
          .then(function(data) {
            // Store new gift wrap key if available
            if (data && data.items && data.items.length > 0) {
              self.giftWrapKey = data.items[0].key;
            }
            
            // Build notification message based on type
            var message = self.getAdjustmentNotificationText(notificationType, shouldHave);
            self.showCustomNotification(message);
            
            // Rebuild cart
            document.dispatchEvent(new CustomEvent('cart:build'));
            
            // Fetch updated cart
            return fetch('/cart.js');
          })
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            // Clear adjustment flag before dispatching event
            self.isAdjusting = false;
            
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
          })
          .catch(function(error) {
            console.error('Error adjusting gift wrap combination:', error);
            self.isAdjusting = false;
          });
      },
      
      getAdjustmentNotificationText: function(type, shouldHave) {
        var baseText = '';
        
        switch (type) {
          case 'upgraded':
            baseText = this.upgradedText;
            break;
          case 'downgraded':
            baseText = this.downgradedText;
            break;
          default:
            baseText = this.adjustedText;
        }
        
        // Add specifics about the new combination
        var detailText = '';
        if (shouldHave.numLarge > 0) {
          detailText += shouldHave.numLarge + ' Large';
        }
        if (shouldHave.numLarge > 0 && shouldHave.numSmall > 0) {
          detailText += ' + ';
        }
        if (shouldHave.numSmall > 0) {
          detailText += shouldHave.numSmall + ' Small';
        }
        
        // If base text contains specific variant info, just return it
        // Otherwise append the detail
        if (baseText.indexOf('Large') !== -1 || baseText.indexOf('Small') !== -1) {
          return baseText;
        }
        
        return baseText + (detailText ? ' (' + detailText + ')' : '');
      },
      
      adjustGiftWrapVariant: function(giftWrapItem, newSize, oldSize) {
        this.getVariantIdBySize(newSize)
          .then(function(newVariantId) {
            // Get gift message if it exists
            var giftMessage = giftWrapItem.properties && giftWrapItem.properties['Gift Message'] 
              ? giftWrapItem.properties['Gift Message'] 
              : '';

            // Remove old variant
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: giftWrapItem.key,
                quantity: 0
              })
            })
            .then(function() {
              // Add new variant
              var formData = {
                items: [{
                  id: newVariantId,
                  quantity: 1
                }]
              };

              // Preserve gift message if it exists
              if (giftMessage) {
                formData.items[0].properties = {
                  'Gift Message': giftMessage
                };
              }

              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
              });
            });
          }.bind(this))
          .then(function(response) { return response.json(); })
          .then(function(data) {
            // Update the gift wrap key
            if (data.items && data.items.length > 0) {
              this.giftWrapKey = data.items[0].key;
            }

            // Show notification
            this.showAdjustmentNotification(newSize, oldSize);

            // Rebuild cart
            document.dispatchEvent(new CustomEvent('cart:build'));

            // Fetch updated cart
            return fetch('/cart.js');
          }.bind(this))
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
          })
          .catch(function(error) {
            console.error('Error adjusting gift wrap variant:', error);
          });
      },

      showCustomNotification: function(message) {
        // Find the notification element in the fixed header
        var notification = document.querySelector('[data-gift-wrap-notification]');
        
        if (!notification) {
          console.warn('Gift wrap notification container not found');
          return;
        }

        notification.textContent = message;
        notification.classList.add('is-visible');
      },
      
      hideNotification: function() {
        var notification = document.querySelector('[data-gift-wrap-notification]');
        if (notification) {
          notification.classList.remove('is-visible');
          notification.textContent = '';
        }
      },
      
      checkGiftWrapAfterProductAdded: function() {
        // Reload config from DOM (should have new cart data)
        this.bindAddButton();
        
        // Skip if not using points
        if (!this.usePoints || !this.giftWrapProductId) {
          return;
        }
        
        // Fetch fresh cart data and check adjustment
        fetch('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            // Check if gift wrap is in cart
            var giftWrapItems = [];
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].product_id == this.giftWrapProductId) {
                giftWrapItems.push(cart.items[i]);
              }
            }
            
            console.log('checkGiftWrapAfterProductAdded:', {
              giftWrapInCart: giftWrapItems.length > 0,
              itemCount: cart.items.length
            });
            
            // If gift wrap is in cart, check if adjustment needed
            if (giftWrapItems.length > 0) {
              this.checkAndAdjustGiftWrapVariants(cart, giftWrapItems);
            }
          }.bind(this))
          .catch(function(error) {
            console.error('Error checking gift wrap after product added:', error);
          });
      },
      
      showAdjustmentNotification: function(newSize, oldSize) {
        // Set notification text based on upgrade/downgrade using class-level properties
        var notificationText = '';
        if (newSize === 'large' && oldSize === 'small') {
          notificationText = this.upgradedText || 'Gift wrap upgraded to Large based on cart contents';
        } else if (newSize === 'small' && oldSize === 'large') {
          notificationText = this.downgradedText || 'Gift wrap changed to Small based on cart contents';
        }
        
        this.showCustomNotification(notificationText);
      },

      resetAddButton: function() {
        if (this.addButton) {
          this.addButton.disabled = false;
          var originalText = this.addButton.getAttribute('data-original-text');
          if (!originalText) {
            // Store original text first time
            originalText = this.addButton.textContent;
            this.addButton.setAttribute('data-original-text', originalText);
          }
          this.addButton.textContent = originalText;
        }
      },

      handleAdd: function(evt) {
        evt.preventDefault();
        
        // Read from button for display-specific settings, fall back to config
        var skipDrawer = this.addButton.getAttribute('data-skip-drawer') === 'true';
        var numLarge = parseInt(this.configEl ? this.configEl.getAttribute('data-num-large') : this.addButton.getAttribute('data-num-large')) || 0;
        var numSmall = parseInt(this.configEl ? this.configEl.getAttribute('data-num-small') : this.addButton.getAttribute('data-num-small')) || 0;
        
        console.log('Gift wrap add clicked:', {
          allowMultiple: this.allowMultiple,
          numLarge: numLarge,
          numSmall: numSmall,
          largeVariantId: this.largeVariantId,
          smallVariantId: this.smallVariantId
        });
        
        // Build items array based on combination
        var items = [];
        
        if (this.allowMultiple && (numLarge > 0 || numSmall > 0)) {
          // Add multiple gift wraps
          if (numLarge > 0 && this.largeVariantId) {
            items.push({
              id: parseInt(this.largeVariantId),
              quantity: numLarge
            });
          }
          if (numSmall > 0 && this.smallVariantId) {
            items.push({
              id: parseInt(this.smallVariantId),
              quantity: numSmall
            });
          }
        } else {
          // Single gift wrap - use variant ID from button or config
          var variantId = this.addButton.getAttribute('data-variant-id');
          if (!variantId) {
            // Fall back to appropriate size based on config
            variantId = numLarge > 0 ? this.largeVariantId : this.smallVariantId;
          }
          if (!variantId) {
            console.error('No variant ID found');
            return;
          }
          items.push({
            id: parseInt(variantId),
            quantity: 1
          });
        }

        if (items.length === 0) {
          console.error('No items to add');
          return;
        }
        
        console.log('Adding items to cart:', items);

        // Store original button text if not already stored
        if (!this.addButton.getAttribute('data-original-text')) {
          this.addButton.setAttribute('data-original-text', this.addButton.textContent);
        }

        this.addButton.disabled = true;
        this.addButton.textContent = this.addButton.getAttribute('data-loading-text') || 'Adding...';

        // Add gift wrap(s) to cart
        var formData = {
          items: items
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          console.log('Add to cart response status:', response.status);
          return response.json();
        })
        .then(data => {
          console.log('Add to cart response data:', data);
          
          // Check for errors
          if (data.status === 422 || data.message) {
            console.error('Cart add error:', data.message || data.description);
            alert('Error adding gift wrap: ' + (data.message || data.description || 'Unknown error'));
            this.addButton.disabled = false;
            this.addButton.textContent = this.addButton.getAttribute('data-original-text') || 'Add';
            return;
          }
          
          // Store the cart key for the first gift wrap item
          if (data.items && data.items.length > 0) {
            this.giftWrapKey = data.items[0].key;
          }
          
          // Hide the upsell
          if (this.upsell) {
            this.upsell.style.display = 'none';
          }

          // Trigger cart rebuild to show gift wrap item immediately
          document.dispatchEvent(new CustomEvent('cart:build'));

          // Open the gift wrap drawer only if not skipping
          if (!skipDrawer) {
            this.open();
          }

          // Trigger cart update event
          return fetch('/cart.js');
        })
        .then(response => {
          if (response) {
            return response.json();
          }
        })
        .then(cart => {
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
          }
        })
        .catch(error => {
          console.error('Error adding gift wrap:', error);
          alert('Error adding gift wrap: ' + error.message);
          this.addButton.disabled = false;
          this.addButton.textContent = this.addButton.getAttribute('data-original-text') || 'Add';
        });
      },

      handleConfirm: function(evt) {
        evt.preventDefault();

        var giftMessage = this.messageInput ? this.messageInput.value : '';

        // If there's a message, update the cart item with the message property
        if (giftMessage && this.giftWrapKey) {
          var formData = {
            id: this.giftWrapKey,
            quantity: 1,
            properties: {
              'Gift Message': giftMessage
            }
          };

          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(cart => {
            this.close();
            // Trigger cart rebuild to show updated items
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
          })
          .catch(error => {
            console.error('Error updating gift message:', error);
            this.close();
            // Still rebuild cart even if message update fails
            document.dispatchEvent(new CustomEvent('cart:build'));
          });
        } else {
          this.close();
          // Rebuild cart to show gift wrap item
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
      },

      open: function() {
        this.drawer.classList.add('drawer--is-open');
        document.body.classList.add('js-drawer-open');
        this.isOpen = true;

        // Close cart drawer
        var cartDrawer = document.getElementById('CartDrawer');
        if (cartDrawer) {
          cartDrawer.style.transform = 'translateX(-100px)';
          cartDrawer.style.opacity = '0.3';
        }
      },

      close: function() {
        this.drawer.classList.remove('drawer--is-open');
        document.body.classList.remove('js-drawer-open');
        this.isOpen = false;

        // Restore cart drawer
        var cartDrawer = document.getElementById('CartDrawer');
        if (cartDrawer) {
          cartDrawer.style.transform = '';
          cartDrawer.style.opacity = '';
        }

        // Reset message input
        if (this.messageInput) {
          this.messageInput.value = '';
          this.updateCharCount();
        }

        // Reset add button
        if (this.addButton) {
          this.addButton.disabled = false;
        }
      },

      updateCharCount: function() {
        if (this.messageInput && this.charCountEl) {
          var count = this.messageInput.value.length;
          this.charCountEl.textContent = count;
        }
      }
    });

    return GiftWrap;
  })();

  window.theme = theme;
})();

